export default __webpack_public_path__ + "img/default-header.432b9f36.jpg";